// Generated by Melange

import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_cabinet__Document from "../../../grpc/Document.js";
import * as Buhta_cabinet__Dropdowns from "../../molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_cabinet__FormView from "../../html/FormView.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(onClose) {
  return function (contractor) {
    return function (data) {
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const dispatchToasts = match$1[1];
      const match$2 = React.useState(function () {
            return false;
          });
      const setUpdated = match$2[1];
      const updated = match$2[0];
      const initialData_iban = data.iban;
      const initialData_bank_name = data.bank_name;
      const initialData_bic = data.bic;
      const initialData = {
        iban: initialData_iban,
        bank_name: initialData_bank_name,
        bic: initialData_bic,
        default: false
      };
      const match$3 = React.useState(function () {
            return initialData;
          });
      const setBankAccount = match$3[1];
      const bankAccount = match$3[0];
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        children: "Изменить реквизиты"
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-6 h-6",
                                              src: StaticAsset.src("/static/icons/close.svg")
                                            }),
                                        onClick: (function (param) {
                                            Curry._1(onClose, updated);
                                          })
                                      })
                                ],
                                className: "px-6 py-4 flex justify-between items-center"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                                onSubmit: (function (param) {
                                    const __x = Buhta_cabinet__Document.ContractorBankAccountService.update(tenant, contractor, data.id, bankAccount);
                                    $$Promise.get(__x, (function (result) {
                                            if (result.TAG !== /* Ok */0) {
                                              return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                            }
                                            Curry._1(setUpdated, (function (param) {
                                                    return true;
                                                  }));
                                            Curry._1(dispatchToasts, {
                                                  TAG: /* Add */0,
                                                  _0: {
                                                    id: Buhta_core__Toast.generateId(undefined),
                                                    text: "Реквизиты успешно обновлены",
                                                    kind: "success",
                                                    onClick: (function (param) {
                                                        
                                                      })
                                                  }
                                                });
                                          }));
                                  }),
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                label: "IBAN",
                                                type_: "text",
                                                name: "iban",
                                                required: true,
                                                onChange: (function (value) {
                                                    Curry._1(setBankAccount, (function (state) {
                                                            return {
                                                                    iban: value,
                                                                    bank_name: state.bank_name,
                                                                    bic: state.bic,
                                                                    default: state.default
                                                                  };
                                                          }));
                                                  }),
                                                className: "mb-4",
                                                value: bankAccount.iban
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__Dropdowns.BankSelect.make, {
                                                bank_id: 0,
                                                onBankSelect: (function (bank) {
                                                    Curry._1(setBankAccount, (function (state) {
                                                            return {
                                                                    iban: state.iban,
                                                                    bank_name: bank.name,
                                                                    bic: bank.bic,
                                                                    default: state.default
                                                                  };
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "px-6 py-8"
                                      }),
                                  JsxRuntime.jsx("hr", {}),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                              title: "Сохранить",
                                              className: "px-4 py-2",
                                              text: /* He5 */1,
                                              type_: "submit"
                                            }),
                                        className: "px-6 py-3 flex justify-end"
                                      })
                                ]
                              })
                        ],
                        className: "w-156 bg-white rounded-md shadow-payroll",
                        onClick: (function (ev) {
                            ev.stopPropagation();
                          })
                      }),
                  className: "absolute inset-0 bg-black/24 flex justify-center items-center",
                  onClick: (function (param) {
                      Curry._1(onClose, updated);
                    })
                });
    };
  };
}

function UpdateBankAccountModal(Props) {
  return Curry._1(make(Props.onClose)(Props.contractor), Props.data);
}

const make$1 = UpdateBankAccountModal;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
